import { useState } from "react";
import { toast } from "sonner";
import { Database, Loader2, CheckCircle2, XCircle, MinusCircle } from "lucide-react";
import api, { formatApiError } from "@/pages/cauzioni/cauApi";
import { Button } from "@/components/ui/button";

const dt = (v) => { try { return new Date(v).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }); } catch { return v; } };

function Riga({ ok, titolo, children, testid }) {
  const Icon = ok === true ? CheckCircle2 : ok === false ? XCircle : MinusCircle;
  const col = ok === true ? "text-emerald-600" : ok === false ? "text-red-600" : "text-slate-400";
  return (
    <div className="flex gap-2.5 py-2" data-testid={testid}>
      <Icon size={16} className={`${col} mt-0.5 shrink-0`} />
      <div className="text-sm"><div className="font-medium text-slate-800">{titolo}</div><div className="text-slate-600 text-xs mt-0.5">{children}</div></div>
    </div>
  );
}

// Verifica su banche dati ufficiali (VIES, Registro Imprese) + dati dell'anagrafica Suite.
export default function CauBancheDati({ p, onUpdate }) {
  const [busy, setBusy] = useState(false);
  const bd = p.bancheDati;
  const run = async () => {
    setBusy(true);
    try { await api.post(`/pratiche/${p.id}/banche-dati`); toast.success("Banche dati verificate"); await onUpdate(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const v = bd?.vies || {}, ri = bd?.registroImprese || {}, an = bd?.anagrafica || {};
  return (
    <div className="border border-slate-200 rounded-sm p-4 mb-5 bg-white" data-testid="cau-banche-dati">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2"><Database size={16} className="text-teal-700" />
          <div><div className="text-sm font-semibold text-slate-900">Banche dati ufficiali</div>
            <div className="text-xs text-slate-500">{bd ? `Ultima verifica ${dt(bd.eseguitoIl)}` : "Non ancora verificate"} · usate nella relazione con indicazione della fonte</div></div>
        </div>
        <Button variant="outline" size="sm" className="rounded-sm" onClick={run} disabled={busy} data-testid="cau-verifica-banche-dati">
          {busy && <Loader2 size={14} className="mr-1.5 animate-spin" />} {bd ? "Aggiorna verifica" : "Verifica P.IVA"}
        </Button>
      </div>
      {bd && (
        <div className="mt-3 divide-y divide-slate-100">
          <Riga ok={v.valid} titolo="VIES (Commissione Europea)" testid="cau-bd-vies">
            {v.valid ? `P.IVA ${bd.partitaIva} valida${v.ragione_sociale ? ` · ${v.ragione_sociale}` : ""}${v.indirizzo ? ` · ${v.indirizzo.replace(/\n/g, " ")}` : ""}`
              : v.valid === false ? `P.IVA ${bd.partitaIva} non valida` : (v.errore || "Non verificata")}
          </Riga>
          <Riga ok={ri.disponibile ? true : null} titolo="Registro Imprese" testid="cau-bd-ri">
            {ri.disponibile ? Object.entries(ri.dati || {}).map(([k, x]) => `${k.replace(/_/g, " ")}: ${x}`).join(" · ") : (ri.motivo || "Non disponibile")}
          </Riga>
          <Riga ok={Object.keys(an).length ? true : null} titolo="Anagrafica AssieticaSuite" testid="cau-bd-anagrafica">
            {Object.keys(an).length ? Object.entries(an).map(([k, x]) => `${k}: ${x}`).join(" · ") : "Nessun dato aggiuntivo in anagrafica"}
          </Riga>
        </div>
      )}
    </div>
  );
}
